import React from 'react'

function DoorOpenIcon({
   className = "h-6 w-6 fill-white"
}) {
   return (
      <svg className={ className } viewBox="0 0 24 24">
         <path d="M5 5v14a1 1 0 0 0 1 1h3v-2H7V6h2V4H6a1 1 0 0 0-1 1zm14.242-.97-8-2A1 1 0 0 0 10 3v18a.998.998 0 0 0 1.242.97l8-2A1 1 0 0 0 20 19V5a1 1 0 0 0-.758-.97zM15 12.188a1.001 1.001 0 0 1-2 0v-.377a1 1 0 1 1 2 .001v.376z"></path>
      </svg>
   )
}

export default DoorOpenIcon